import { Component, Input, OnChanges } from '@angular/core';

@Component({
	selector: 'app-valid-message-form',
	templateUrl: './valid-message-form.component.html'
})
export class ValidMessageFormComponent implements OnChanges {
	@Input() type: 'error' | 'success' | 'info' | 'warning' = 'error';
	@Input() message: string | undefined;

	config: IMessage | undefined;

	ngOnChanges(): void {
		this.config = this.getMessage();
	}

	getMessage(): IMessage {
		switch (this.type) {
			case 'success':
				return { ficon: 'fa fa-check-circle-o', style: 'val_correcto' };
			case 'info':
				return { ficon: 'fa fa-info-circle', style: 'val_info' };
			case 'warning':
				return { ficon: 'fa fa-exclamation-triangle', style: 'val_advertencia' };
			default:
				return { ficon: 'fa fa-times-circle-o', style: 'val_error' };
		}
	}
}

interface IMessage {
	ficon: string;
	style: string;
}
